function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M185.737 363L186 272.296L93.2958 272L93.0001 362.672L185.737 363Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M186.46 452.975L186.755 362.393L93.7555 452.679L186.46 452.975Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M278.869 543.884L279.164 453.303L186.46 452.975L278.869 543.884Z",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M467.43 91.566L467.726 0.95145L375.021 0.656181L467.43 91.566Z",
  fill: "url(#paint3_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M463.982 544.213L464.245 453.598L371.573 453.303L371.277 543.884L463.982 544.213Z",
  fill: "url(#paint4_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M93.7045 362.91L93.9672 272.295L1.29569 272L1.00012 362.582L93.7045 362.91Z",
  fill: "url(#paint5_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M279.165 453.303L279.46 362.688L186.756 362.393C186.592 412.424 226.458 453.139 275.815 453.303H279.165Z",
  fill: "url(#paint6_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M97.9922 452.417L93.756 456.715L93.7231 460.192L101.44 452.417H97.9922Z",
  fill: "url(#paint7_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M113.459 452.45L93.6903 472.397V475.874L116.907 452.483L113.459 452.45Z",
  fill: "url(#paint8_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M128.927 452.516L93.6248 488.079V491.557L132.375 452.516H128.927Z",
  fill: "url(#paint9_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M144.394 452.549L93.5919 503.761V507.239L147.842 452.581L144.394 452.549Z",
  fill: "url(#paint10_linear)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M159.861 452.614L93.5259 519.41V522.921L163.309 452.614H159.861Z",
  fill: "url(#paint11_linear)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M175.328 452.679L93.4931 535.092V538.603L178.776 452.679H175.328Z",
  fill: "url(#paint12_linear)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M186.428 457.108L101.145 543.032H104.593L186.428 460.586V457.108Z",
  fill: "url(#paint13_linear)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M186.395 472.791L116.612 543.064L120.06 543.097L186.395 476.268V472.791Z",
  fill: "url(#paint14_linear)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M186.329 488.472L132.079 543.13H135.527L186.329 491.95V488.472Z",
  fill: "url(#paint15_linear)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M186.296 504.155L147.546 543.196H150.994L186.263 507.632L186.296 504.155Z",
  fill: "url(#paint16_linear)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M186.23 519.804L163.013 543.228H166.461L186.23 523.314V519.804Z",
  fill: "url(#paint17_linear)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M186.197 535.486L178.48 543.294H181.928L186.164 538.996L186.197 535.486Z",
  fill: "url(#paint18_linear)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M466.806 182.476L467.102 91.8614H465.099C415.019 91.6973 374.266 132.116 374.102 182.181L466.806 182.476Z",
  fill: "url(#paint19_linear)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M186.704 181.615L187 91.0005H184.997C134.917 90.8365 94.1643 131.255 94.0001 181.32L186.704 181.615Z",
  fill: "url(#paint20_linear)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M371.376 362.885L371.672 272.27L278.967 271.942L278.672 362.557L371.376 362.885Z",
  fill: "url(#paint21_linear)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M464.376 272.566L464.639 181.951L371.967 181.656L371.672 272.27L464.376 272.566Z",
  fill: "url(#paint22_linear)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M557.081 272.861L557.343 182.279L464.639 181.951L464.376 272.566L557.081 272.861Z",
  fill: "url(#paint23_linear)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M556.785 363.476L557.08 272.861H553.731C504.374 272.697 464.245 313.116 464.08 363.18L556.785 363.476Z",
  fill: "url(#paint24_linear)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M371.081 453.467L371.376 362.885L278.672 362.557L278.376 453.171L371.081 453.467Z",
  fill: "url(#paint25_linear)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M463.785 453.795L464.081 363.18L371.376 362.885C371.212 412.917 411.079 453.631 460.436 453.795H463.785Z",
  fill: "url(#paint26_linear)"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M92.4093 545L92.7049 454.385L0.000505375 454.09C-0.163689 504.122 39.7028 544.836 89.0598 545H92.4093Z",
  fill: "url(#paint27_linear)"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M556.49 454.09L556.785 363.476L464.081 363.18L463.785 453.795L556.49 454.09Z",
  fill: "url(#paint28_linear)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M559.872 90.9099L560.168 0.295268L467.463 0L467.168 90.6146L559.872 90.9099Z",
  fill: "url(#paint29_linear)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M283.5 181.361L279.23 185.658V189.169L286.948 181.361H283.5Z",
  fill: "url(#paint30_linear)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M298.967 181.426L279.197 201.34L279.165 204.851L302.415 181.426H298.967Z",
  fill: "url(#paint31_linear)"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M314.433 181.458L279.131 217.022V220.532L317.881 181.491L314.433 181.458Z",
  fill: "url(#paint32_linear)"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M329.9 181.524L279.098 232.703L279.066 236.214L333.348 181.524H329.9Z",
  fill: "url(#paint33_linear)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M345.368 181.557L279.033 248.386V251.897L348.816 181.59L345.368 181.557Z",
  fill: "url(#paint34_linear)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M360.835 181.623L279 264.069L278.968 267.546L364.283 181.623H360.835Z",
  fill: "url(#paint35_linear)"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M371.935 186.052L286.652 271.975L290.1 272.008L371.935 189.562V186.052Z",
  fill: "url(#paint36_linear)"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M371.902 201.734L302.119 272.041H305.567L371.869 205.244L371.902 201.734Z",
  fill: "url(#paint37_linear)"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M371.836 217.416L317.553 272.074L321.034 272.106L371.836 220.926V217.416Z",
  fill: "url(#paint38_linear)"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M371.803 233.098L333.02 272.139H336.501L371.77 236.609L371.803 233.098Z",
  fill: "url(#paint39_linear)"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M371.737 248.78L348.487 272.172L351.935 272.205L371.737 252.291V248.78Z",
  fill: "url(#paint40_linear)"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M371.672 264.462L363.955 272.238H367.403L371.672 267.973V264.462Z",
  fill: "url(#paint41_linear)"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M471.009 90.5489L466.74 94.8139V98.3243L474.458 90.5489H471.009Z",
  fill: "url(#paint42_linear)"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M486.477 90.5818L466.708 110.496L466.675 114.006L489.925 90.5818H486.477Z",
  fill: "url(#paint43_linear)"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M501.943 90.6469L466.641 126.178V129.688L505.391 90.6469H501.943Z",
  fill: "url(#paint44_linear)"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M517.411 90.6804L466.609 141.86L466.576 145.371L520.859 90.7132L517.411 90.6804Z",
  fill: "url(#paint45_linear)"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M532.878 90.7458L466.543 157.542V161.052L536.326 90.7458H532.878Z",
  fill: "url(#paint46_linear)"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M548.345 90.7786L466.51 173.224L466.478 176.735L551.793 90.8114L548.345 90.7786Z",
  fill: "url(#paint47_linear)"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M559.445 95.2076L474.162 181.164H477.61L559.445 98.718V95.2076Z",
  fill: "url(#paint48_linear)"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M559.412 110.89L489.629 181.196L493.077 181.229L559.379 114.4L559.412 110.89Z",
  fill: "url(#paint49_linear)"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M559.346 126.572L505.096 181.262H508.544L559.346 130.082V126.572Z",
  fill: "url(#paint50_linear)"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M559.313 142.254L520.53 181.295L524.011 181.328L559.28 145.764L559.313 142.254Z",
  fill: "url(#paint51_linear)"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M559.247 157.936L535.997 181.36H539.478L559.247 161.446V157.936Z",
  fill: "url(#paint52_linear)"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M559.215 173.618L551.465 181.393L554.946 181.426L559.182 177.128L559.215 173.618Z",
  fill: "url(#paint53_linear)"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M98.532 181L94.263 185.265V188.775L101.98 181H98.532Z",
  fill: "url(#paint54_linear)"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M113.999 181.033L94.23 200.947L94.1972 204.457L117.447 181.033H113.999Z",
  fill: "url(#paint55_linear)"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M129.465 181.098L94.1635 216.629V220.139L132.913 181.098H129.465Z",
  fill: "url(#paint56_linear)"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M144.933 181.131L94.1315 232.311L94.0986 235.822L148.381 181.164L144.933 181.131Z",
  fill: "url(#paint57_linear)"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M160.401 181.197L94.0659 247.993V251.504L163.849 181.197H160.401Z",
  fill: "url(#paint58_linear)"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M175.868 181.23L94.0329 263.675L94.0001 267.186L179.316 181.262L175.868 181.23Z",
  fill: "url(#paint59_linear)"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M186.967 185.659L101.685 271.615H105.133L186.967 189.169V185.659Z",
  fill: "url(#paint60_linear)"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M186.935 201.341L117.152 271.647L120.6 271.68L186.902 204.851L186.935 201.341Z",
  fill: "url(#paint61_linear)"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M186.869 217.023L132.619 271.713H136.067L186.869 220.533V217.023Z",
  fill: "url(#paint62_linear)"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M186.836 232.705L148.053 271.746L151.534 271.779L186.803 236.215L186.836 232.705Z",
  fill: "url(#paint63_linear)"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M186.77 248.387L163.52 271.811H167.001L186.77 251.897V248.387Z",
  fill: "url(#paint64_linear)"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M186.737 264.069L178.987 271.844L182.468 271.877L186.704 267.579L186.737 264.069Z",
  fill: "url(#paint65_linear)"
});

var _ref68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 94.111,
  y1: 271.055,
  x2: 186.2,
  y2: 362.412,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B2F2F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8963,
  stopColor: "#30ACCE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 139.405,
  y1: 406.591,
  x2: 186.249,
  y2: 453.092,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 209.695,
  y1: 429.474,
  x2: 301.693,
  y2: 520.799,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 398.259,
  y1: -22.8445,
  x2: 490.257,
  y2: 68.4805,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B2F2F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8963,
  stopColor: "#30ACCE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 372.386,
  y1: 452.357,
  x2: 464.385,
  y2: 543.682,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1109,
  stopColor: "#FAED7D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8378,
  stopColor: "#F0B018"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 2.10903,
  y1: 271.055,
  x2: 94.1076,
  y2: 362.38,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1109,
  stopColor: "#FAED7D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8378,
  stopColor: "#F0B018"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 200.702,
  y1: 348.223,
  x2: 292.7,
  y2: 439.548,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1037,
  stopColor: "#3098CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3200AA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 93.1686,
  y1: 459.636,
  x2: 101,
  y2: 451.963,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 93.1179,
  y1: 475.316,
  x2: 116.678,
  y2: 452.232,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 93.0677,
  y1: 490.997,
  x2: 132.357,
  y2: 452.501,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 93.0163,
  y1: 506.677,
  x2: 148.034,
  y2: 452.77,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 92.9655,
  y1: 522.358,
  x2: 163.713,
  y2: 453.039,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 92.9155,
  y1: 538.038,
  x2: 179.392,
  y2: 453.308,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 102.3,
  y1: 544.214,
  x2: 188.777,
  y2: 459.484,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 117.765,
  y1: 544.266,
  x2: 188.512,
  y2: 474.948,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 133.231,
  y1: 544.318,
  x2: 188.248,
  y2: 490.412,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: 148.695,
  y1: 544.369,
  x2: 187.985,
  y2: 505.873,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: 164.161,
  y1: 544.422,
  x2: 187.721,
  y2: 521.337,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear",
  x1: 179.627,
  y1: 544.473,
  x2: 187.457,
  y2: 536.801,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear",
  x1: 401.504,
  y1: 117.47,
  x2: 466.855,
  y2: 182.343,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear",
  x1: 121.402,
  y1: 116.609,
  x2: 186.754,
  y2: 181.482,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear",
  x1: 279.789,
  y1: 271.029,
  x2: 371.787,
  y2: 362.354,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear",
  x1: 372.78,
  y1: 180.732,
  x2: 464.778,
  y2: 272.057,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1109,
  stopColor: "#FAED7D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8378,
  stopColor: "#F0B018"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear",
  x1: 465.481,
  y1: 181.038,
  x2: 557.479,
  y2: 272.363,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1037,
  stopColor: "#3098CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3200AA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear",
  x1: 478.266,
  y1: 377.667,
  x2: 570.85,
  y2: 286.952,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B2F2F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8963,
  stopColor: "#30ACCE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear",
  x1: 279.499,
  y1: 361.632,
  x2: 371.497,
  y2: 452.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear",
  x1: 385.329,
  y1: 348.712,
  x2: 477.328,
  y2: 440.037,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0842,
  stopColor: "#E86A8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8676,
  stopColor: "#E82A8C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint27_linear",
  x1: 13.9601,
  y1: 439.939,
  x2: 105.958,
  y2: 531.265,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint28_linear",
  x1: 464.902,
  y1: 362.244,
  x2: 556.9,
  y2: 453.569,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear",
  x1: 468.294,
  y1: -0.917764,
  x2: 560.292,
  y2: 90.4073,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1109,
  stopColor: "#FAED7D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8378,
  stopColor: "#F0B018"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint30_linear",
  x1: 278.68,
  y1: 188.604,
  x2: 286.511,
  y2: 180.931,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint31_linear",
  x1: 278.629,
  y1: 204.285,
  x2: 302.19,
  y2: 181.201,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint32_linear",
  x1: 278.578,
  y1: 219.965,
  x2: 317.868,
  y2: 181.469,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint33_linear",
  x1: 278.527,
  y1: 235.646,
  x2: 333.545,
  y2: 181.738,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint34_linear",
  x1: 278.477,
  y1: 251.327,
  x2: 349.225,
  y2: 182.008,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint35_linear",
  x1: 278.427,
  y1: 267.007,
  x2: 364.904,
  y2: 182.277,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint36_linear",
  x1: 287.812,
  y1: 273.183,
  x2: 374.288,
  y2: 188.453,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint37_linear",
  x1: 303.277,
  y1: 273.235,
  x2: 374.024,
  y2: 203.917,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint38_linear",
  x1: 318.742,
  y1: 273.287,
  x2: 373.76,
  y2: 219.381,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint39_linear",
  x1: 334.207,
  y1: 273.339,
  x2: 373.496,
  y2: 234.843,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint40_linear",
  x1: 349.672,
  y1: 273.391,
  x2: 373.232,
  y2: 250.307,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint41_linear",
  x1: 365.139,
  y1: 273.442,
  x2: 372.97,
  y2: 265.77,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2046,
  stopColor: "#F34E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8634,
  stopColor: "#F1961C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint42_linear",
  x1: 466.203,
  y1: 97.7851,
  x2: 474.034,
  y2: 90.112,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint43_linear",
  x1: 466.152,
  y1: 113.466,
  x2: 489.712,
  y2: 90.3814,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint44_linear",
  x1: 466.1,
  y1: 129.146,
  x2: 505.39,
  y2: 90.6494,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint45_linear",
  x1: 466.05,
  y1: 144.826,
  x2: 521.068,
  y2: 90.9196,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint46_linear",
  x1: 466,
  y1: 160.508,
  x2: 536.747,
  y2: 91.1884,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint47_linear",
  x1: 465.95,
  y1: 176.188,
  x2: 552.426,
  y2: 91.4571,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint48_linear",
  x1: 475.334,
  y1: 182.364,
  x2: 561.811,
  y2: 97.6333,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint49_linear",
  x1: 490.799,
  y1: 182.416,
  x2: 561.546,
  y2: 113.097,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint50_linear",
  x1: 506.264,
  y1: 182.468,
  x2: 561.282,
  y2: 128.561,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint51_linear",
  x1: 521.729,
  y1: 182.519,
  x2: 561.019,
  y2: 144.022,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint52_linear",
  x1: 537.195,
  y1: 182.57,
  x2: 560.755,
  y2: 159.486,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint53_linear",
  x1: 552.661,
  y1: 182.623,
  x2: 560.491,
  y2: 174.95,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint54_linear",
  x1: 93.7251,
  y1: 188.236,
  x2: 101.556,
  y2: 180.563,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint55_linear",
  x1: 93.6746,
  y1: 203.917,
  x2: 117.235,
  y2: 180.832,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint56_linear",
  x1: 93.6228,
  y1: 219.597,
  x2: 132.912,
  y2: 181.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint57_linear",
  x1: 93.5729,
  y1: 235.277,
  x2: 148.591,
  y2: 181.371,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint58_linear",
  x1: 93.5222,
  y1: 250.959,
  x2: 164.27,
  y2: 181.639,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint59_linear",
  x1: 93.4721,
  y1: 266.639,
  x2: 179.949,
  y2: 181.908,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint60_linear",
  x1: 102.857,
  y1: 272.815,
  x2: 189.333,
  y2: 188.084,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint61_linear",
  x1: 118.322,
  y1: 272.867,
  x2: 189.069,
  y2: 203.548,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint62_linear",
  x1: 133.787,
  y1: 272.919,
  x2: 188.805,
  y2: 219.012,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint63_linear",
  x1: 149.252,
  y1: 272.97,
  x2: 188.542,
  y2: 234.473,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint64_linear",
  x1: 164.718,
  y1: 273.021,
  x2: 188.278,
  y2: 249.937,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint65_linear",
  x1: 180.183,
  y1: 273.074,
  x2: 188.014,
  y2: 265.401,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A00E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8E00DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2411,
  stopColor: "#6C01B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#51019E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6144,
  stopColor: "#3E028B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8041,
  stopColor: "#33027F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F027B"
})));

var SvgHero = function SvgHero(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 561,
    height: 545,
    viewBox: "0 0 561 545",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHero, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hero.059f9c78.svg";
export { ForwardRef as ReactComponent };